{
  "en": {
    "apps": {
      "ai_assistant": {
        "color": "var(--brand-7)",
        "description": "Explore and remix helpful chatbots for you and your students.",
        "descriptionPupils": "Discover helpful chatbots for you and your students.",
        "icon": "bi-grid-3x3",
        "longDescriptionHtml": "With this tool, students can learn about historical or fictional characters and interact with them.",
        "name": "Assistants Catalog ",
        "useCasesHtml": "<ul> <li>Creative writing: Students can write essays or short stories in which they interact with historical or fictional characters and share their thoughts and feelings.</li> <li>Presentations and speeches: Students can research historical or fictional characters and give presentations to demonstrate their knowledge and discuss their personalities.</li> <li>Quiz and trivia games: Students can create quiz or trivia games where they can ask questions and test their knowledge about historical or fictional characters.</li> </ul>"
      },
      "ai_audio": {
        "description": "Change written text into spoken audio, making materials more accessible.",
        "icon": "bi-soundwave",
        "name": "Text to Speech Creator"
      },
      "ai_chat": {
        "customBadgeLabel": "New Assistants",
        "description": "Use the instant support from the AI Chat for teaching strategies, lesson planning, and more.",
        "descriptionPupils": "Try different tasks and find out how AI ​​can help you in your learning journey.",
        "longDescriptionHtml": "Let our AI Assistant help you design your lessons and organize your work.",
        "name": "Chat with AI",
        "useCasesHtml": "<ul> <li>Have letters to parents translated into <strong>different languages</strong>.</li> <li>Get suggestions for <strong>tasks and sample solutions</strong>.</li> <li>Have <strong>lists of material</strong> created for classroom experiments.</li> <li>Have complex <strong>texts summarized</strong> in a short and age-appropriate way.</li> <li>Have them plan the schedule for the <strong>parent-teacher conference</strong>.</li> <li>Have them <strong>find the most important information</strong> on a topic.</li> <li>Have <strong>code snippets</strong> created or completed.</li> </ul>",
        "videos": [
          {
            "id": "1162203532"
          },
          {
            "id": "1162203230"
          }
        ]
      },
      "ai_converter": {
        "description": "Create podcasts, keynote speeches, audio tracks and transcripts from various sources.",
        "longDescriptionHtml": "The AI for Media Creation offers you new possibilities for designing and converting content for your lessons.",
        "name": "AI for Media Creation",
        "useCasesHtml": "<ul><li>Turn content into a <strong>podcast or keynote speech</strong> on the topic of your choice - with audio track and transcript</li><li>Create <strong>listening comprehension tasks</strong> for your lessons and have audio tracks from various sources recorded for you.</li><li><strong>Convert voice messages and videos into text</strong> and use the transcript for further tasks.</li><li>Create a transcript from photos and text of <strong>manuscripts</strong>.</li></ul>",
        "videos": [
          {
            "id": "1162204420"
          }
        ]
      },
      "ai_dialog": {
        "description": "Convert written dialog into spoken audio for custom podcasts with two speakers.",
        "icon": "bi-chat-quote",
        "name": "Dialog Creator"
      },
      "ai_document_qa": {
        "description": "Ask questions and generate different text types and assignments based on PDF files.",
        "descriptionPupils": "Ask questions about the content of PDFs and documents.",
        "longDescriptionHtml": "Search specific documents for information and have them prepared specifically for you.",
        "name": "PDF Chat",
        "useCasesHtml": "<ul> <li>Ask questions about the entire contents of a PDF.</li> <li>Have the most important points of a source summarized in any length.</li> <li>Search documents for content and have them prepared in the form you want.</li> <li>Get a finished outline of the content in a PDF.</li> <li>Have ready-made question-answer pairs for tests and learning controls based on a specific source created for you.</li> </ul>",
        "videos": [
          {
            "id": "1109320950"
          }
        ]
      },
      "ai_feedback": {
        "description": "Receive automated grading and feedback suggestions for student assignments.",
        "longDescriptionHtml": "Save valuable time assessing your students work with automated grading suggestions based on your own criteria and assignments.",
        "name": "Grading Assistant",
        "useCasesHtml": "<ul> <li>Receive grading suggestions and lists of mistakes and improvement suggestions for student assignments.</li> <li>Set your own evaluation criteria and receive individual feedback to student work</li> <li>Upload photos of student texts and have them transcribed and corrected with only one click.</li> </ul>",
        "videos": [
          {
            "id": "1162201624"
          }
        ]
      },
      "ai_feedback_result": {
        "name": "Grading Assistant Results"
      },
      "ai_image": {
        "description": "Turn a thought into a picture and illustrate concepts and ideas in the classroom.",
        "descriptionPupils": "Try to create creative images with different descriptions and styles.",
        "longDescriptionHtml": "<strong>Turn a thought into a picture</strong> and illustrate concepts and ideas in the classroom.",
        "name": "Image Generator",
        "useCasesHtml": "<ul> <li>Create royalty-free images to <strong>illustrate teaching material</strong>.</li> <li>Get <strong>multiple versions of images</strong> and themes in different styles.</li> <li>Discuss associations, styles, and <strong>creative possibilities</strong> with students.</li> </ul>",
        "videos": [
          {
            "id": "1107011689"
          }
        ]
      },
      "ai_lecture": {
        "description": "Generate a script plus audio and turn your content into a compelling talk or monologue.",
        "icon": "bi-book",
        "name": "Keynote Creator"
      },
      "ai_message": {
        "name": "AI Prompts"
      },
      "ai_mini_tool": {
        "customBadgeLabel": "55+ Tools",
        "description": "Find pre-written prompts and inspirations for a variety of use cases.",
        "icon": "bi-lightbulb",
        "longDescriptionHtml": "Over 55+ Prompts take repetitive tasks out of your school day—from lesson planning to parent communication—without having to write prompts yourself.",
        "name": "Prompt Lab",
        "useCasesHtml": "<ul> <li>Plan <strong>lesson series and individual classes</strong> tailored to subject, grade level, and topic.</li> <li>Create <strong>materials and assignments</strong> with minimal input in seconds.</li> <li>Find <strong>differentiation ideas</strong> to adapt tasks to different levels.</li> <li>Formulate <strong>feedback and assessments</strong> with suitable phrasing aids.</li> <li>Prepare <strong>parent meetings and emails</strong> clearly and in the right tone.</li> <li>Get <strong>creative project and lesson ideas</strong> for new input.</li> </ul>",
        "videos": [
          {
            "id": "1205810117"
          }
        ]
      },
      "ai_mini_tool_request": {
        "name": "Prompt Lab Requests"
      },
      "ai_my_assistants": {
        "description": "Create your own chatbot with background knowledge and specific instructions.",
        "icon": "bi-stars",
        "name": "My Assistants"
      },
      "ai_persona": {
        "description": "Have the AI simulate different characters and engage in conversations.",
        "descriptionPupils": "Chat with exciting and famous people or with funny characters.",
        "longDescriptionHtml": "Let AI take on different characters and interview your chatbot about its knowledge and experience.",
        "name": "Character Chat",
        "useCasesHtml": "<ul> <li><strong>Chat with historical figures</strong> about their life and find out how they view the current affairs of their lifetime.</li> <li><strong>Learn from experts</strong> in a specific field and ask them to share their experience with you.</li> <li><strong>Interview a writer</strong> about the genesis and background of a book you are reading.</li> <li>Test the possibilities and limits of artificial intelligence with <strong>funny characters</strong></li> <li>Choose your favorite person or character as a <strong>study buddy</strong> and ask them to coach you through your learning process or a specific task.</li> </ul>"
      },
      "ai_podcast": {
        "description": "Turn a topic of your choice into an interactive podcast, including script and audio",
        "icon": "bi-mic",
        "name": "Podcast Creator"
      },
      "ai_summary": {
        "description": "Create a summary from a text, website or other various sources.",
        "icon": "bi-journal-text",
        "name": "Summary Generator"
      },
      "ai_text": {
        "description": "Extract text from an image or document file or convert handwriting to edit content digitally.",
        "icon": "bi-file-earmark-font",
        "name": "Image to Text Converter"
      },
      "ai_transcript": {
        "description": "Convert audio files into accurate transcripts quickly and effortlessly.",
        "icon": "bi-vector-pen",
        "name": "Transcription Generator"
      },
      "ai_translation": {
        "description": "Create a translation from a text, a website or other various sources.",
        "icon": "bi-translate",
        "name": "Translator"
      },
      "audio_recorder": {
        "description": "Create audio recordings and share them securely.",
        "icon": "bi-file-music",
        "longDescriptionHtml": "Create audio recordings and share them via link or QR code.",
        "name": "Audio Recorder",
        "useCasesHtml": "<ul> <li>Create and share audio feedback for homework, project work or exercises</li> <li>Offer auditory support, for example, by providing additional information to students with reading difficulties</li> <li>Send greetings and voice messages to students</li> <li>Create and share audio recordings with hidden hints for a EduBreakout</li> </ul>",
        "videos": [
          {
            "id": "1139396412"
          }
        ]
      },
      "classroom_screen": {
        "description": "Create multimedia teaching boards and structure your lesson content efficiently.",
        "longDescriptionHtml": "Create multimedia teaching boards and structure your lesson content. Design your lessons live and digitally.",
        "name": "Teaching Board",
        "useCasesHtml": "<ul> <li>Visualize lesson content and enrich it with <strong>multimedia content</strong></li> <li>Note and organize content and elements on a <strong>dynamic whiteboard</strong></li> <li><strong>Collect ideas collaboratively</strong> with your students</li> <li>Share work instructions on a <strong>creative board</strong></li> <li>Use timers and work symbols to support your <strong>classroom management</strong></li> </ul>",
        "videos": [
          {
            "id": "1176877350"
          }
        ]
      },
      "file_sharing": {
        "description": "Upload files and provide secure access to others through a link. ",
        "longDescriptionHtml": "Upload files and share via link or QR code.",
        "name": "File Sharing",
        "useCasesHtml": "<ul> <li>Share teaching material, homework or other content.</li> <li>Share content with temporary access rights or password protection</li> <li>Share teaching material in tablet classes</li> </ul>",
        "videos": [
          {
            "id": "1123573079"
          }
        ]
      },
      "link_shortener": {
        "description": "Generate a shortened link to make sharing more convenient. ",
        "longDescriptionHtml": "Shorten a URL and share it via link or QR code.",
        "name": "URL Shortener",
        "useCasesHtml": "<ul> <li>Share links to teaching material, videos or other digital content</li> <li>Share links with temporary access rights or password protection</li> </ul>",
        "videos": [
          {
            "id": "1123490498"
          }
        ]
      },
      "pinboard": {
        "defaults": {
          "boardName": "My own board",
          "cardName": "Card no 1",
          "listName": "First list"
        },
        "description": "Work together on a shared board to organize tasks, structure ideas and share content effectively. ",
        "longDescriptionHtml": "Use a board to collaborate with others. Use cards to share content in an organized fashion.",
        "name": "Pinboard",
        "useCasesHtml": "<ul> <li><strong>Brainstorm</strong> on a topic, statement, project or idea</li> <li>Create a digital <strong>post-it board</strong> where your students can collaborate together</li> <li><strong>Collect and organize</strong> your students' work and research results</li> </ul>",
        "videos": [
          {
            "id": "1174783593"
          }
        ]
      },
      "project": {
        "name": "Projects in shared space"
      },
      "pupil_feedback": {
        "description": "Offer students AI-generated feedback along with suggestions to improve their writing skills.",
        "longDescriptionHtml": "This tool provides students with AI-generated feedback and differentiated suggestions for improving texts and assignments.",
        "name": "Feedback for Students",
        "useCasesHtml": "<ul> <li>Accompany your students' writing tasks <strong>with AI-based feedback</strong> in real-time.</li> <li>Support students with AI in their independent learning process and <strong>experience noticeable relief</strong> yourself.</li> <li>Control the AI-generated feedback through <strong>individually defined criteria</strong>.</li> </ul>",
        "videos": [
          {
            "id": "1174742582"
          }
        ]
      },
      "qrcodes": {
        "description": "Generate QR codes from URLs and include them in teaching materials. ",
        "longDescriptionHtml": "Create a QR code from a URL and then share it digitally with your students.",
        "name": "QR Code Generator",
        "useCasesHtml": "<ul> <li>Share teaching materials, presentations or digital resources directly via <strong>QR codes</strong></li> <li><strong>Facilitate access</strong> to online surveys or feedback forms for your students</li> <li>Integrate QR codes into worksheets or posters to provide <strong>additional information</strong></li> </ul>"
      },
      "school_class": {
        "description": "Create a shared space and let students work independently with specific tools.",
        "longDescriptionHtml": "Each student gets their own space where they can work on a specific assignment or project.",
        "name": "Shared Space",
        "newFeaturesHtml": "<strong>New:</strong> Invite other teachers to your projects, filter activities selectively, attach your own files and link classrooms to your school.",
        "useCasesHtml": "<ul> <li><strong>Test and discuss the potential and risks</strong> of artificial intelligence with students.</li> <li>Let students use the AI ​​assistant for texts as a <strong>co-pilot for the creation of texts</strong>.</li> <li>Let your students ask the AI ​​about a specific topic and <strong>apply their previous knowledge</strong> to check and assess the results.</li> <li>Use the <strong>AI ​​as a study buddy</strong> to help your students with a work assignment or project.</li> <li>Let students have a <strong>conversation with historical figures</strong> (or funny characters) with the help of the Character Chat.</li> </ul>",
        "useCasesTitle": "Here’s how you can use it:",
        "videoIntroText": "Our video shows you how to set up a classroom step by step in about 5 minutes.",
        "videos": [
          {
            "id": "1033754760"
          }
        ]
      },
      "screen_recorder": {
        "description": "Create screen recordings and share them securely with others.",
        "longDescriptionHtml": "Create screen recordings and share them via link or QR code.",
        "name": "Screen Recorder",
        "useCasesHtml": "<ul> <li>Create <strong>instructional videos</strong> and <strong>video assignments</strong></li> <li>Present a <strong>website</strong> or <strong>tool</strong> using an <strong>on-screen recording</strong></li> <li>Provide <strong>video feedback</strong> on digitally submitted homework, project work, and class assignments</li> <li>Show how to work out a <strong>sample solution in an on-screen video</strong></li> </ul>",
        "videos": [
          {
            "id": "1139388454"
          }
        ]
      },
      "surveys": {
        "description": "Create a survey with various question types, share it via link or QR code, and analyze the results.",
        "icon": "bi-clipboard-data",
        "longDescriptionHtml": "Create a survey and choose from different question and task types. Share your survey via link or QR code and evaluate the results.",
        "name": "Survey",
        "useCasesHtml": "<ul> <li>Create surveys, forms and questionnaires and review the results</li> <li>Create and share digital quizzes and exercises and collect the results</li> <li>Test students' prior knowledge and let them share opinions and self-assessments</li> </ul>",
        "videos": [
          {
            "id": "1162201278"
          }
        ]
      },
      "to_teach_worksheet_import": {
        "description": "Import worksheets from your to teach account directly into fobizz.",
        "name": "Worksheet from to teach"
      },
      "text_editor": {
        "description": "Create collaborative  documents to write and edit content with students and colleagues.",
        "descriptionPupils": "Write and edit documents together.",
        "longDescriptionHtml": "Create collaborative text documents to write and edit text and brainstorm ideas with students and colleagues.",
        "name": "Text Editor",
        "useCasesHtml": "<ul> <li>Group projects and brainstorming: Students can work together on projects and collect ideas or topics for discussion in class.</li> <li>Summaries and reports: Students can collaboratively write documents and organize and structure the content.</li> <li>Creative writing and writing conferences: Students can collaboratively write, revise, and improve their own or other people's writing.</li> <li>AI assistance: The integrated Artificial Intelligence helps with writing and revising the content and supports with spelling and grammar tips as well as translation assistance.</li> </ul>",
        "videos": [
          {
            "id": "1174824311"
          }
        ]
      },
      "video_recorder": {
        "description": "Create video recordings and share them securely with others.",
        "longDescriptionHtml": "Create video recordings and share them via link or QR code.",
        "name": "Video Recorder",
        "useCasesHtml": "<ul> <li>Create and share video recordings for homework, explanatory videos, and personal support</li> <li>Video feedback for homework, project work or exercises</li> <li>Create learning aids or additional exercises for internal differentiation</li> <li>Create and share video messages with temporary access rights or password protection</li> </ul>",
        "videos": [
          {
            "id": "1176119433"
          }
        ]
      },
      "website": {
        "description": "Create a website without any prior technical knowledge and share it via link or QR code.",
        "icon": "bi-window",
        "longDescriptionHtml": "Create a website without any prior technical knowledge and share it via link or QR code.",
        "name": "Website",
        "useCasesHtml": "<ul> <li>Just like a <strong>blank sheet of paper</strong>, you can fill the website with any kind of content you want</li> <li>Create <strong>digital notepads, letters to parents or blog articles</strong> and share them with parents and students</li> <li>Create <strong>multimedia learning paths</strong> or <strong>link collections</strong></li> </ul>",
        "videos": [
          {
            "id": "1172185135"
          }
        ]
      },
      "word_clouds": {
        "description": "Create word clouds for brainstorming and visualizing ideas, adding creativity to discussions.",
        "longDescriptionHtml": "Create a word cloud from a list of words or in collaboration with students.",
        "name": "Word Cloud",
        "newlineSeparatedWordsPlaceholder": "Wenn\nFliegen\nhinter\nFliegen\nfliegen\nfliegen\nFliegen\nhinter\nFliegen\nher",
        "useCasesHtml": "<ul> <li>Brainstorming</li> <li>Recalling prior knowledge or associations</li> <li>Evaluate moods and attitudes</li> </ul>",
        "videos": [
          {
            "id": "1172184912"
          }
        ]
      },
      "worksheet": {
        "consolidatedDescription": "Create worksheets yourself, generate them with AI, or import from to teach.",
        "description": "Create a worksheet with various question types, share it via link or QR code, and assess the results.",
        "longDescriptionHtml": "Create a worksheet by selecting different types of questions and tasks. Share your worksheet via link or QR code and evaluate the results.",
        "name": "Worksheet",
        "useCasesHtml": "<ul> <li>Create fun digital worksheets, forms and questionnaires and review the results</li> <li>Create and share digital quizzes and exercises and collect the results</li> <li>Test students' prior knowledge and let them share opinions and self-assessments</li> </ul>",
        "videos": [
          {
            "id": "1173959857",
            "title": "Generate worksheets with AI"
          },
          {
            "id": "1174734752",
            "title": "Create a worksheet yourself"
          }
        ]
      },
      "worksheet_wizard": {
        "description": "Generate customized worksheets featuring diverse assignments and instant feedback.",
        "name": "AI Worksheet Assistant"
      }
    }
  }
}
